import { ChangeEvent, useState } from "react";
import Loc from "../../Loc/Loc";
import { WebApi } from "../WebApi/WebApi";
import MyTimer from "./MyTimer";

interface WaitingForCodeProps {
    setAccess: React.Dispatch<React.SetStateAction<boolean>>;
    setWaitingForCode: React.Dispatch<React.SetStateAction<boolean>>;
    type: string;
    email: string;
    hash: string;
}

export default function WaitingForCode(props: WaitingForCodeProps) {
    const webApi = new WebApi();
    const [code, setCode] = useState("");
    const [error, setError] = useState(false);
    const [checkingCode, setCheckCodeState] = useState(false);
    const time = new Date();
    time.setSeconds(time.getSeconds() + 600); // 10 minutes timer
    const HandleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        setError(false);
        setCode(event.target.value);
    }
    const HandleOnClickCheck = () => {
        const accessPublicPortal = () => {
            props.setAccess(true);
        }
        setCheckCodeState(true);
        webApi.publicDownloadCollections(props.hash, props.email, code)
        .then(() => {
            setCheckCodeState(false);
            accessPublicPortal();
        })
        .catch(error => {
            console.log(error);
            setCheckCodeState(false);
            setError(true);
        })
    }
    const HandleOnClickBack = () => {
        props.setWaitingForCode(false);
    }

    return (
        <div>
            {props.type === "mail" && <div style={{color: 'white'}}>{Loc.trad().WaitingForCodeSent}</div>}
            <div style={{color: 'white', fontSize: '2rem'}}>{Loc.trad().WaitingForCodeTimer}{props.type}.</div>
            <MyTimer expiryTimestand={time}></MyTimer>
            <input type="text" className="form-control mt-2" style={{width: '380px', marginLeft: 'auto', marginRight: 'auto'}} onChange={HandleOnChange} />
            {(checkingCode || error) && <div style={{marginLeft: 'auto', marginRight: 'auto', width: '380px'}}><div style={{fontSize: '1.5rem'}} className={checkingCode ? "alert alert-info mt-3" : "alert alert-danger mt-3"} role="alert">{checkingCode ? Loc.trad().WaitingForCodeChecking : Loc.trad().WaitingForCodeError}{checkingCode && <span className="spinner-border spinner-border-sm mr-1"></span>}</div></div>}
            <div style={{marginTop: '1vh'}}>
                <button type="button" className="btn btn-primary btn-lg" style={{margin: '10px'}} onClick={HandleOnClickCheck}>{Loc.trad().WaitingForCodeCheck}</button>
                <button type="button" className="btn btn-secondary btn-lg" style={{margin: '10px'}} onClick={HandleOnClickBack}>{Loc.trad().WaitingForCodeBack}</button>
            </div>
        </div>
    )
}